import React, { useContext } from 'react'
import Form from 'app/React/Components/Form/Form'
import StepFigure from 'app/React/Components/Main/StepFigure'
import EquipmentBox from 'app/React/Components/Form/EquipmentBox'
import { ConfiguratorContext } from "app/React/ConfiguratorContainer";

export default function Step1() {
  const { currentVariant } = useContext(ConfiguratorContext)

  const steps = currentVariant.steps ?? {}

  return (
    <div id='step-1'>
      <StepFigure step={1}/>
      <Form form={steps['1']} variantsetting paymenttypesetting leasingkmfield>
        <EquipmentBox/>
      </Form>
    </div>
  )
}
